<div id="accountInfo" class="bordered flex-centered">
  @if (logoUrl()) {
    <img id="vbLogo-small" [alt]="altText()" [src]="logoUrl()" />
  }
  <div class="flex-centered nameAndIban">
    <div id="name">
      <p class="text--small little-padding">{{ customerName() }}<br /></p>
      <p class="text--small text--bold little-padding">IBAN</p>
    </div>
    <span class="text--small text--bold bottom-row-mobile">{{ iban() | ibanFormatter }}</span>
  </div>
</div>
